<i18n>
{
  "ru":{
    "username": "Имя",
    "password": "Пароль",
    "login": "Войти",
    "two_factor_auth_code": "2FA код",
    "login_enter_auth_code": "Необходимо ввести 2FA код",
    "login_enter_auth_code_wrong": "Вы должны ввести 6 цифр",
    "login_enter_auth_code_error": "Неверный 2FA код. В целях безопасности QR-код был обновлён.",
    "two_factor_description": "2FA помогает защитить доступ к данным и операциям по платежам. Дополнительное подтверждение исключает несанкционированный вход.",
    "passed2Fa": "Вы успешно прошли 2FA"
  },
  "en":{
    "username": "Username",
    "password": "Password",
    "login": "Login",
    "two_factor_auth_code": "2FA code",
    "login_enter_password": "You must enter password",
    "login_enter_auth_code": "You must enter 2FA code",
    "login_enter_auth_code_wrong": "You must enter 6 digits",
    "login_enter_auth_code_error": "Incorrect 2FA code. For security purposes, the QR code has been updated.",
    "two_factor_description": "2FA helps protect access to data and payment transactions. The additional verification prevents unauthorized access.",
    "passed2Fa": "You have successfully completed 2FA"
  }
}
</i18n>
<template>
  <div class="login__wrapper">
    <technical-alert/>
    <el-card :class="[{ 'login-wrapper-card-submit': isSubmitMode }, 'login__wrapper_card']" v-loading="loading" :body-style="elCardStyle">
      <div class="login__form_block">
        <div class="login__form_block_header">
          <img src="../../../assets/img/logo.svg" alt="Logo Webpay">
        </div>
        <div :class="[{'login__form_block_content-submit': isSubmitMode}, 'login__form_block_content']">
          <el-form
            :model="form"
            ref="form"
            :rules="formRules"
            @submit.native.prevent="login('form')"
          >
            <el-form-item v-show="!isSubmitMode" prop="username">
              <el-input
                :placeholder="$t('username')"
                v-model="form.username"
              ></el-input>
            </el-form-item>
            <el-form-item v-show="!isSubmitMode" prop="password">
              <el-input
                ref="passwordCodeInput"
                type="password"
                :placeholder="$t('password')"
                v-model="form.password"
              ></el-input>
            </el-form-item>
            <img v-if="isSubmitMode" class="aligner qr-code" :src="imageSource" alt="qr code">
            <div v-if="isSubmitMode" class="secret-code">{{ secretCode }}</div>
            <el-form-item v-show="twoFactor" prop="authCode">
              <el-input
                  ref="authCodeInput"
                  :placeholder="$t('two_factor_auth_code')"
                  v-model="form.authCode"
              ></el-input>
            </el-form-item>
            <p class="aligner">
              <el-button round type="primary" native-type="submit">{{
                $t("login")
              }}</el-button>
            </p>
          </el-form>

          <p class="aligner">
            <el-button round type="primary" @click="oldVersion">{{
              $t("old_version")
            }}</el-button>
          </p>
        </div>
        <div class="login__form_block_footer">
          <p>
            Copyright © {{ new Date().getFullYear() }} WEBPAY™ All Rights
            Reserved.
          </p>
        </div>
      </div>
      <div v-if="isSubmitMode" class="two_fa__info_block">
        <div class="two_fa__info_block_header two-fa-title">Подключение двухфакторной аутентификации (2FA)</div>
        <div class="two_fa__info_block_body_wrapper">
          <div class="two_fa__info_block_body_header">Для повышения безопасности доступа необходимо подключить двухфакторную аутентификацию.</div>
          <div class="two_fa__info_block_body_info"><span class="two-fa-title">1.</span>&nbsp;Установите приложение <span class="two-fa-title">Google Authenticator</span><br>&nbsp;&nbsp;&nbsp;(если ещё не установлено).</div>
          <div class="two_fa__info_block_body_info">
            <div class="two_fa__info_block_body_info_paragraph"><span class="two-fa-title">2.</span>&nbsp;Откройте приложение и добавьте новый аккаунт:</div>
            <div class="two_fa__info_block_body_info_paragraph">&nbsp;&nbsp;&nbsp;- отсканируйте QR-код,</div>
            <div class="two_fa__info_block_body_info_paragraph">&nbsp;&nbsp;&nbsp;- либо введите секретный код вручную.</div>
          </div>
          <div class="two_fa__info_block_body_info"><span class="two-fa-title">3.</span>&nbsp;Введите одноразовый код, сгенерированный<br>&nbsp;&nbsp;&nbsp; приложением.</div>
          <div class="two_fa__info_block_body_info"><span class="two-fa-title">4.</span>&nbsp;Нажмите &laquo;Войти&raquo;.</div>
        </div>
        <div class="two_fa__info_block_footer">Если код введён неверно, необходимо повторить настройку.
          После успешного подключения произойдёт завершение сессии.
          Для продолжения работы необходимо заново войти в систему, указав логин и пароль, а затем — код из <span class="two-fa-title">Google Authenticator</span>.</div>
      </div>
    </el-card>
  </div>
</template>

<script>
import authSvc from '../../core/authSvc'
import apiRes from '../../core/apiRes'

export default {
  name: 'login',
  data: function () {
    return {
      billingUrl: process.env.VUE_APP_BILLING_API_URL,
      loginUri: '/login',
      form: {
        username: '',
        password: '',
        authCode: ''
      },
      loading: false,
      secret: false,
      twoFactor: false,
      secretCode: '',
      qrCodeString: '',
      jwt: '',
      twoFaPassed: false,
      submissionAttempts: 0
    }
  },
  computed: {
    isSubmitMode() {
      return this.twoFactor && !this.secret
    },
    imageSource() {
      return `data:image/png;base64,${this.qrCodeString}`
    },
    formRules() {
      const rules = {}
      if (!this.isSubmitMode) {
        rules.username = [
          { required: true, message: this.$t('login_enter_username'), trigger: 'blur' }
        ]
        rules.password = [
          { required: true, message: this.$t('login_enter_password'), trigger: 'blur' }
        ]
      }
      if (this.twoFactor) {
        rules.authCode = [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(this.$t('login_enter_auth_code')))
            } else if (!/^\d{6}$/.test(value)) {
              callback(new Error(this.$t('login_enter_auth_code_wrong')))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }]
      }
      return rules
    },
    elCardStyle() {
      return this.isSubmitMode ? { display: 'flex', 'flex-direction': 'row' } : {}
    }
  },
  methods: {
    async loginOnBilling(username, password, authCode) {
      const payload = { username, password }
      if (authCode) {
        Object.assign(payload, { authCode })
      }
      if (this.secretCode !== '') {
        Object.assign(payload, { secretCode: this.secretCode })
      }
      const response = await fetch(this.buildUrl(this.loginUri), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify(payload)
      })
      const {
        data: {
          secret = false,
          two_factor: twoFactor = false,
          secret_code: secretCode = '',
          qr_code_string: qrCodeString = '',
          auth_token: accessToken = ''
        }
      } = await response.json()
      let jwt
      if (this.isSubmitMode && accessToken !== '') {
        this.twoFaPassed = true
        jwt = ''
      } else {
        this.twoFaPassed = false
        jwt = accessToken
      }
      Object.assign(this, {
        secret,
        twoFactor,
        secretCode,
        qrCodeString,
        jwt
      })
    },
    async getSettings () {
      apiRes.payoutSettings = null
      const jwtToken = window.localStorage.getItem('jwt_token')
      const response = await fetch(`${this.billingUrl}/v1/app-settings/get-menu-permissions`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${jwtToken}`,
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
      const { data: { settings } } = await response.json()
      apiRes.payoutSettings = settings.payout
    },
    async login(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            this.removeFocusFromInputs()
            await this.loginOnBilling(this.form.username, this.form.password, this.form.authCode)
            if (this.jwt === '') {
              // 2fa in progress mode. QR showing. Waiting for auth code.
              if (this.isSubmitMode) {
                if (this.submissionAttempts > 0) {
                  alert(this.$t('login_enter_auth_code_error'))
                }
                this.resetAuthCode()
                this.loading = false
                this.submissionAttempts++
                return
              }
              // 2fa passed. alert and logout.
              if (this.twoFaPassed) {
                alert(this.$t('passed2Fa'))
                this.twoFaPassed = false
                this.resetPasswordAndAuthCode()
                this.loading = false
                return
              }
              // 2fa mode. Waiting for auth code.
              this.resetPasswordAndAuthCode()
              this.loading = false
              return
            }
            window.localStorage.setItem('jwt_token', this.jwt)
          } catch (e) {
            alert('Ошибка авторизации на новом биллинге')
          }

          if (this.jwt === '') {
            this.loading = false
            this.reset()
            return
          }

          try {
            await this.getSettings()
          } catch (e) {
            alert('Error on loading settings.')
          }

          authSvc.login(this.form.username, this.form.password, this.form.authCode).then(res => {
            this.loading = false
            if (!res.error) {
              this.$router.push({ name: 'dashboard' })
            } else {
              this.$notify.error({
                title: this.$t('error'),
                message: this.$t(res.error)
              })
            }
          })
        }
      })
    },
    oldVersion () {
      document.cookie = 'j=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
      document.cookie = 'o=true'
      location.assign(location.origin)
    },
    buildUrl(uri) {
      if (uri.endsWith('/')) {
        uri = uri.slice(0, -1)
      }
      return this.billingUrl + uri
    },
    resetPasswordAndAuthCode(formName = 'form') {
      this.form.password = ''
      this.form.authCode = ''
      setTimeout(() => {
        const username = this.form.username
        this.$refs[formName].resetFields()
        this.form.username = username
      }, 0)
    },
    resetAuthCode(formName = 'form') {
      this.form.authCode = ''
      setTimeout(() => {
        this.$refs[formName].clearValidate(['authCode'])
      }, 0)
    },
    reset() {
      Object.assign(this, {
        secret: false,
        twoFactor: false,
        secretCode: '',
        qrCodeString: '',
        jwt: ''
      })
      this.resetPasswordAndAuthCode()
      this.twoFaPassed = false
    },
    removeFocusFromInputs() {
      if (this.$refs.authCodeInput) {
        const input = this.$refs.authCodeInput.$refs.input
        if (document.activeElement === input) {
          input.blur()
        }
      }
      if (this.$refs.passwordCodeInput) {
        const input = this.$refs.passwordCodeInput.$refs.input
        if (document.activeElement === input) {
          input.blur()
        }
      }
    }
  }
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}
.login__wrapper {
  width: 100%;
  min-height: 100%;
  background: url(img/lc_bg.jpg) center / cover no-repeat;
  padding-top: 15vh;
  padding-bottom: 20px;
  box-sizing: border-box;
}
.login__wrapper_card {
  position: relative;
  max-width: 400px;
  width: 95%;
  margin: 0 auto;
}
.login-wrapper-card-submit {
  max-width: fit-content;
}
.login__wrapper_card:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 20px;
  height: 100%;
  background-color: #00a3e8;
  border-radius: 15px 0 0 15px;
}
.el-card__body {
  padding: 0 0 0 20px;
}
.login__form_block {
  height: 100%;
  max-width: 280px;
  margin: 10px auto 0;
  padding: 10px  10px;
}
.two_fa__info_block {
  max-width: 570px;
  background-color: #F6F2F1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 30px;
  line-height: 1.7;
  padding: 45px 40px;
  letter-spacing: 0.04em;
}
.two_fa__info_block_header {
  font-size: 1.7em;
  line-height: 1.4;
}
.two_fa__info_block_footer {
  background-color: #FCFBFA;
  padding: 10px;
  border-radius: 12px;
  font-size: 0.8em;
}
.two_fa__info_block_body_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 15px;
}
.two-fa-title {
  color: #153A7B;
  font-weight: bold;
}
.login__form_block_content {
  margin-top: 30px;
}
.login__form_block_content-submit {
  margin-top: 30px;
  padding: 0 20px;
}
.login__form_block_content form input[type="text"],
.login__form_block_content form input[type="password"] {
  height: 50px;
  margin-top: 15px;
}
.login__form_block_footer {
  margin: 24px 0 0;
}
.login__form_block_footer p {
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  color: #C0C4CC;
}
.secret-code {
  word-break: break-all;
  white-space: normal;
  text-align: left;
}
.qr-code {
  width: 100%;
  display: block;
  margin: 0 auto 10px auto;
}

@media only screen and (max-width: 576px) {
  .login__wrapper_card {
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
